import type { FunctionComponent } from 'react';
import { Head } from 'nordic/head';

import { Page } from 'nordic/page';

import { AndesProvider } from '@andes/context';
import type { Locale } from 'nordic/i18n';
import type { BrandNames } from 'mp-cross';
import type { HubStepsInfo, Step } from '../../../services/types';
import type { ContactWordings, HubWordings } from '../../wordings';
import Hub from './components/Hub';

import StyleAsset from '../../components/style-asset';
import { GATrack, MelidataTrack } from '../../../services/Track';
import UserDataWrapper from '../../components/user-data-context';
import type { CommonProps } from '../../helpers/commonProps';
import { PageProvider } from '../../contexts/PageContext';
import { HubB2BWordings } from '../../wordings/hub/b2b';

export type ViewProps = {
  wordings: {
    hubWordings: HubWordings
    contactWordings: ContactWordings,
    stepsPendingWordings: HubWordings,
    stepsConflictWordings: HubWordings,
    hubB2bWordings?: HubB2BWordings,
  },
  hubInfo: HubStepsInfo
  locale: Locale
  defaultProps: CommonProps
  tracks: {
    melidata: MelidataTrack
    analytics: GATrack
    editDeclaredEmail: MelidataTrack
    contactCX: MelidataTrack
  },
  urls: {
    declaredEmail: string
    feedbackStep: string
    b2b?: string
  },
  configs: {
    parityFlow?: boolean,
    hubB2b?: boolean,
  },
  animatedCongratsStep: Step | undefined
  enabledContact: boolean
  translations: any // eslint-disable-line
  appTheme: BrandNames
}

const HubView: FunctionComponent<ViewProps> = (props: ViewProps) => {
  const {
    wordings,
    hubInfo,
    locale,
    defaultProps,
    tracks,
    urls,
    animatedCongratsStep,
    enabledContact,
    translations,
    appTheme,
    configs,
  } = props;
  const { melidata, analytics, editDeclaredEmail, contactCX } = tracks;
  const { hubWordings } = wordings;

  const stateProps = {
    wordings,
    locale,
    hubInfo,
    defaultProps,
    tracks,
    urls,
    animatedCongratsStep,
    enabledContact,
    translations,
    appTheme,
    configs,
  };

  return (
    <AndesProvider locale={locale}>
      <Page
        name="hub"
        melidata={melidata}
        analytics={analytics}
        state={stateProps}
        styles={false}
      >
        <StyleAsset viewName="hub" platformId={defaultProps.platformId} />
        <Head>
          <title>{hubWordings.title}</title>
        </Head>
        <PageProvider {...defaultProps}>
          <UserDataWrapper abuseScoring={hubInfo.abuse_scoring}>
            <Hub
              wordings={wordings}
              hubInfo={hubInfo}
              urls={urls}
              editDeclaredEmailTrack={editDeclaredEmail}
              contactCXTrack={contactCX}
              enabledContact={enabledContact}
              animatedCongratsStep={animatedCongratsStep}
              configs={configs}
            />
          </UserDataWrapper>
        </PageProvider>
      </Page>
    </AndesProvider>
  );
};

export default HubView;
